import { ManagedServiceId } from '@axinom/mosaic-id-utils';
import type { ActionData } from '@axinom/mosaic-ui';
import { useFormikContext } from 'formik';
import { useHistory, useParams } from 'react-router-dom';
import type { FormDataIdProvider } from '../../IdentityProviders.types';

export const useGenerateInlineMenuActions: (
  data: FormDataIdProvider,
) => ActionData[] = (data) => {
  const { submitForm, dirty } = useFormikContext<FormDataIdProvider>();
  const history = useHistory();
  const { envId } = useParams<{
    envId: string;
  }>();

  return [
    {
      label: 'View Details',
      onActionSelected: async () => {
        if (dirty) {
          await submitForm();
        }
        history.push(
          `/env/${envId}/services/${ManagedServiceId.ID_SERVICE}/config/identityProviders/${data.idpId}`,
        );
      },
    },
  ];
};
